export default "__VITE_ASSET__ETH15FlM__"